import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=9a5a720e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=9a5a720e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5a720e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a5a720e')) {
      api.createRecord('9a5a720e', component.options)
    } else {
      api.reload('9a5a720e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=9a5a720e&scoped=true&", function () {
      api.rerender('9a5a720e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dw0iCB8iJy7y/JS/comp/DocBox.vue"
export default component.exports